<template>
  <div>
    <div v-if="activeCover" class="activeCover" @click="zoomIt()"></div>
    
    <div v-if="activeMessage" class="message" :style="{'background-color': bgColor}" :class="{'zoom' : addZoom === true}">
      <div class="iconMessage">
        <font-awesome-icon style="font-size:36px;color:#ffffff;" v-if="messageType==='success'" :icon="['fas', 'check-circle']" />
        <font-awesome-icon style="font-size:36px;color:#ffffff;" v-else-if="messageType==='warning'" :icon="['fas', 'exclamation-triangle']" />
        <font-awesome-icon style="font-size:36px;color:#ffffff;" v-else-if="messageType==='error'" :icon="['fas', 'exclamation-square']" />
        <font-awesome-icon style="font-size:36px;color:#ffffff;" v-else :icon="['fas', 'info-circle']" />
      </div>
      <div class="message-content" v-html="messageContent" style="padding:15px 5px 0 72px;">
      </div>
      <div style="position:absolute;top:70px;width:100%;text-align:center;">
        <button @click="close()" style="border-radius:4px; border: 1px solid #ffffff;background-color:transparent;height:24px;font-size:12px;width:100px;color:#ffffff;text-align:center;">OK</button>
      </div>
    </div>
  </div>
</template>

<script>

import { setTimeout } from 'timers'
import { EventBus } from '@/behaviours/event-bus'

export default {
  name: 'OpaAlerts',

  data () {
    return {
      activeCover: false,
      activeMessage: false, // dimissable
      addZoom: false,
      messageContent: '',
      messageType: 'error'
    }
  },

  created () {
    let vm = this
    EventBus.$on('showAlert', (type, message) => {
      vm.showMessage(type, message)
    })
  },

  destroyed () {
    EventBus.$off('showAlert')
  },

  computed: {
    bgColor () {
      let color = '#2e6dd3'
      switch(this.messageType) {
        case 'success':
          color = '#54966b'
          break
        case 'warning':
          color = '#e0c631'
          break
        case 'error':
          color = '#871b20'
          break
      }
      return color
    }
  },

  methods: {
    
    showMessage (type, message) {
      this.activeCover = true
      this.activeMessage = true
      this.messageContent = message
      this.messageType = type
    },

    zoomIt () {
      this.addZoom = true
      setTimeout( () => {this.addZoom = false}, 200)
    },

    close () {
      this.activeCover = false
      this.activeMessage = false
    }
    
  }
}
</script>

<style lang="scss">

.activeCover {
  height: auto;
  min-height:100vh;
  width: 100vw;
  opacity: 0.49;
  background-color: #2A2531;
  position: fixed;
  top: 0px;
  left:0px;
  z-index:29001;
}

.iconMessage {
  position:absolute;
  top:15px;
  left:18px;
}

.message {
  height: 104px;
  width: 320px;
  border-radius: 4px;
  box-shadow: 0 4px 11px 0 rgba(0,0,0,0.35);
  position: fixed;
  top: calc(50vh - 100px );
  left: calc(50vw - 160px);
  z-index:30000;

  .sucesso {
    top:15px;
    left: 15px;
    height: 18px;
    width: 207px;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    position:absolute;
  }

  .atencao {
    top:15px;
    left: 10px;
    height: 18px;
    width: 207px;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    position:absolute;
  }

  .erro {
    top:15px;
    left: 0px;
    height: 18px;
    width: 207px;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    position:absolute;
  }

  .message-content {
    top:8px;
    height: 55px;
    width: 100%;
    color: #FFFFFF;
    font-family: Roboto;
    font-size: 14px;
    line-height: 18px;
    position:absolute;
    text-align:left;
    overflow:auto;
  }

  .dimissMessage {
    cursor: pointer;
    position:absolute;
    right:10px;
    top:5px;
  }

  
}

.loadingModal {
  height: 185px;
  width: 291px;	
  border-radius: 4px;	
  background-color: #706C7A;	
  box-shadow: 0 4px 11px 0 rgba(0,0,0,0.35);
  position: fixed;
  top: calc(50vh - 150px );
  left: calc(50vw - 100px);
  z-index:30000;

  .carregando {
    margin:35px auto 10px;
    height: 18px;	
    width: 207px;	
    color: #12FCC4;	
    font-family: Roboto;	
    font-size: 16px;	
    font-weight: 500;
    line-height: 18px;
    text-align: center;
  }
  .por-favor-aguarde-e {	
    margin:0px auto;
    height: 36px;	
    width: 195px;	
    color: #FFFFFF;	
    font-family: Roboto;	
    font-size: 14px;	
    line-height: 18px;	
    text-align: center;
  }
  .spinner {
    margin: 20px auto;
    animation: anim-spinner 0.6s linear infinite;
  }
  @keyframes anim-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1,1);
  }
  50% {
    transform: scale(1.2,1.2);
  }
  100% {
    transform: scale(1,1);
  }
}

.zoom {
  animation: zoominoutsinglefeatured 0.2s infinite ;
}



</style>
